export const POSITION_SPACING = 20;
export const POSITION_SIZE = 50;
export const POSITION_STROKE_WIDTH = 2;
export const CELL_SIZE = 70;
export const POSITION_FILL_COLOR = '#707070';
export const POSITION_FILL_COLOR_LIGHT = '#e6e7eb';
export const POSITION_BOOKED_COLOR = '#856596';
export const POSITION_HIGHLIGHT_COLOR = '#33C5C2';
export const TEXT_SPACING = 16;
export const FONT_FAMILY = 'sans-serif';
export const FONT_SIZE = 12;
export const FONT_WEIGHT = 200;
export const TOP_PADDING = 20;
